import {
  GetSessionAllVersionIdsRequest,
  GetSessionAllVersionIdsResponse,
  GetSessionAllVersionsRequest,
  GetSessionAllVersionsResponse,
} from "@financial-advisory/data-access/api-types";
import { productRecommendationApi } from "./productRecommendationApi";

export const {
  useGetSessionAllVersionIdsQuery,
  useLazyGetSessionAllVersionIdsQuery,
} = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionAllVersionIds: builder.query<
      GetSessionAllVersionIdsResponse,
      GetSessionAllVersionIdsRequest
    >({
      query: ({ sessionId }) => ({
        url: `sessions/${sessionId}/all-version-ids`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetSessionAllVersionsQuery,
  useLazyGetSessionAllVersionsQuery,
} = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionAllVersions: builder.query<
      GetSessionAllVersionsResponse,
      GetSessionAllVersionsRequest
    >({
      query: ({ sessionId }) => ({
        url: `sessions/${sessionId}/all-versions`,
        method: "GET",
      }),
    }),
  }),
});
